import React, { useState, useEffect } from 'react';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import ModalGenerateKey from 'screens/ModalCreateKey';
import ModalKeycardPrinting from 'screens/ModalKeycardPrinting';
import { RoomDetailsHeaderContainer, Title, Row } from './styles';
import { useMutation } from '@apollo/client';
import { UPDATE_ROOM_STATUS, INVALIDATE_KEY, UNLOCK_DOOR } from 'graphql/service';
import statusMap from 'constants/statusMap';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const RoomDetailsHeader = ({ roomNumber, roomId, roomType, status }) => {

  const [roomStatus, setRoomStatus] = useState('');
  useEffect(() => {
    setRoomStatus(statusMap[status])
  }, [status])

  const [updateRoomStatus] = useMutation(UPDATE_ROOM_STATUS, {
    onCompleted: (data) => {
      if(data) {
        message.success('Room status updated successfully!')
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  })

  const [unlockDoor, { loading: unlockDoorLoading }] = useMutation(UNLOCK_DOOR, {
    onCompleted: (data) => {
      if(data) {
        message.success('Door unlocked successfully!')
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  })
  
  const [invalidateKey, { loading: invalidateKeyLoading }] = useMutation(INVALIDATE_KEY, {
    onCompleted: (data) => {
      if(data) {
        message.success('Key invalidated successfully!')
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  })

  const [deviceId, setDeviceId] = useState('Kiosk 1')
  const [KeyPrintModalIsOpen, setKeyPrintModalIsOpen] = useState(false)

  const statusOptions = [
    'Room Inspected',
    'Room Clean',
    'Room Dirty',
    'Out of Service',
  ]

  const handleChangeRoomStatus = (e) => {
    setRoomStatus(e)
    const statusKey = Object.keys(statusMap).find(key => statusMap[key] === e);
    updateRoomStatus({
      variables: {
        input: {
          roomId: roomId,
          status: statusKey
        },
      },
    })
  }

  const handleUnlockDoor = () => {
    if(unlockDoorLoading) return
    //FIXME: update this when the backend is ready
    // unlockDoor({
    //   variables: {
    //     input: { 
    //       roomNumber: roomNumber
    //     }
    //   },
    // })
  }

  const handleInvalidateKey = () => {
    if(invalidateKeyLoading) return
    //FIXME: update this when the backend is ready
    // invalidateKey({
    //   variables: {
    //     input: { 
    //       roomNumber: roomNumber
    //     }
    //   },
    // })
  }

  return (
    <RoomDetailsHeaderContainer>
      <Title>
        <div className='title'>
          <div className='roomNumber'>ROOM {roomNumber}</div>
          <div className='secondary'>
            {roomType?.name.toUpperCase()} {roomType?.outside && 'OUTSIDE'}
          </div>
        </div>
        <Dropdown
          mainPage
          options={statusOptions}
          value={roomStatus}
          disabled={roomStatus?.includes('Occupied')}
          onChange={handleChangeRoomStatus}
          additionalstyle={`
            .select {
              height: 46px;
              font-size: 20px;
              font-weight: normal;
            }

            @media only screen and (min-width: 1200px) {
              display: none;
            }

            @media only screen and (min-width: 767px) and (max-width: 1200px) {
              width: 300px;
            }

            @media only screen and (max-width: 767px) {
              flex-basis: 70%;
              min-width: 250px;
              max-width: 300px;
              .select {
                height: 37px;
                font-size: 13px;
              }
            }
          `}
        />
      </Title>
      <Row>
        <Dropdown
          mainPage
          options={statusOptions}
          value={statusMap[status]}
          disabled={statusMap[status]?.includes('Occupied')}
          onChange={handleChangeRoomStatus}
          title="ROOM STATUS"
          additionalstyle={`
            width: 300px;
            margin-right: 18px;
            @media only screen and (max-width: 1200px) {
              display: none;
            }
          `}
        />
        <div className='buttonContainer'>
          <Button
            mainPage
            onClick={handleInvalidateKey}
            data-loading={invalidateKeyLoading}
            additionalstyle={`
              width: 134px;
              margin-right: 14px;

              @media only screen and (min-width: 767px) and (max-width: 1200px) {
                width: 163px;
              }
            
              @media only screen and (max-width: 767px) {
                width: 100px;
                margin-right: 5px;
              }
            `}
          >
            {invalidateKeyLoading? null: 'Invalidate Key'}
          </Button>
          <ModalGenerateKey
            mainPage
            buttonStyle={`
              width: 133px;
              margin-right: 14px;
              
              @media only screen and (min-width: 767px) and (max-width: 1200px) {
                width: 162px;
              }
            
              @media only screen and (max-width: 767px) {
                width: 100px;
              }
            `}
            roomNumber={roomNumber}
            deviceId={deviceId}
            setDeviceId={setDeviceId}
            setKeyPrintModalIsOpen={setKeyPrintModalIsOpen}
          />
          <Button
            mainPage
            onClick={handleUnlockDoor}
            data-loading={unlockDoorLoading}
            additionalstyle={`
              width: 123px;

              @media only screen and (min-width: 767px) and (max-width: 1200px) {
                width: 148px;
              }
            
              @media only screen and (max-width: 767px) {
                width: 100px;
                margin-right: 5px;
              }
            `}
          >
            {unlockDoorLoading? null: 'Unlock Door'}
          </Button>
        </div>
        <ModalKeycardPrinting
          isOpen={KeyPrintModalIsOpen}
          setIsOpen={setKeyPrintModalIsOpen}
          buttonLabel={""}
          deviceId={deviceId}
        />
      </Row>
    </RoomDetailsHeaderContainer>
  );
};

export default RoomDetailsHeader;